module.exports = __webpack_public_path__ + "static/media/photoshop.793c4272.svg";